import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import {
  Box,
  Collapse,
  Grid,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import { useTheme } from "@mui/material/styles";
import { useEffect, useRef, useState } from "react";
import "react-datepicker/dist/react-datepicker.css"; // This is necessary for styling
import { useLocation } from "react-router-dom";
import useIsMobile from "../Hooks/useIsMobile";
import apiService from "../Services/api.service";
import CustomButton from "../components/Button";
import CustomDatePicker from "../components/CustomDatePicker";
import ExpandBox from "../components/ExpandBox";
import PageLoader from "../components/Loader";
import BarGraphDialog from "../components/MonthWiseAnalytics";
import Title from "../components/PageTitle";
import PaymentStatusDialog from "../components/PaymentStatusDialog";
import { useToast } from "../components/Toast";
import TransactionsList from "../components/TransactionHistory";
import TransactionDialog from "../components/TransactionPopUp";
const KioskDetails = () => {
  const theme = useTheme();
  const token = localStorage.getItem("token");
  const locationCheck = useLocation();
  const Toast = useToast();
  const isMobile = useIsMobile();
  const { id, kioskName, ClinicName, location, code, status, shipStatus } =
    locationCheck.state || {};
  const [isEditable, setIsEditable] = useState(false);
  const [isDeliveryEditable, setDeliveryEditable] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [openStatus, setStatusOpen] = useState(false);
  const [isContract, setIsContract] = useState(false);
  const [emptyPay, setEmptyPay] = useState(false);
  const handleStatusOpen = () => setStatusOpen(true);
  const handleStatusClose = () => setStatusOpen(false);
  const [openTransaction, setTransactionOpen] = useState(false);
  const [showMonthwise, setMonthwise] = useState(false);
  const handleCloseMonthWise = () => setMonthwise(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const handleOpenDialog = () => {
    setOpenDialog(true); // Open the dialog when button is clicked
  };
  const [contractName, setContractName] = useState(null);
  const handleCloseDialog = () => {
    setOpenDialog(false); // Close the dialog
  };
  const [openSections, setOpenSections] = useState({
    kioskDetails: true,
    deliveryDetails: false,
    shipmentStatus: false,
    paymentStatus: false,
    contractSection: false,
  });

  const toggleSection = (section) => {
    setOpenSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };
 
  const ActivationStatus = {
    NOTACTIVATED: "not activated",
    TEMPORARY: "temporary activated", // Activated for short window
    FULLY_ACTIVE: "fully activated", // Fully activated
    DISABLED: "disabled", // Kiosk disabled
  };
  const ShipmentStatus = {
    PENDING: "pending", // Shipment is pending
    SHIPPED: "shipped", // Shipment has been dispatched
    IN_TRANSIT: "in transit", // Shipment is in transit
    DELIVERED: "delivered", // Shipment has been delivered
    CANCELED: "canceled", // Shipment has been canceled
    RETURNED: "returned", // Shipment has been returned
    DELAYED: "delayed",
    ONHOLD: "on hold",
  };
  const Payment = {
    PAID_FULLY: "paid fully",
    PAID_PARTIALLY: "paid partially",
    AWAITING_PAYMENT: "awaiting payment",
    PAYMENT_OVERDUE: "payment overdue",
    PAID_DELIVERY_DUES: "paid delivery dues", // payment due on delivery are cleared
  };
  const Currency = {
    USD: "USD",
    INR: "INR",
  };
  const [activationStatus, setActivationStatus] = useState(status);
  const prevActivationStatus = useRef(activationStatus);
  const [shipmentStatus, setShipmentStatus] = useState(shipStatus || "NA");

  const [doctorDetails, setDoctorDetails] = useState({
    name: kioskName || "",
    code: code || "",
    clinicName: ClinicName || "",
    location: location || "",
    dwName: "",
  });

  const [deliveryDetails, setdeliveryDetails] = useState({
    address: "Clnic adress" || "",
    ActualDate: null,
    ExpextedDate: null,
    Validity: null,
  });

  const [payment, setPayment] = useState({
    CurrencyStatus: "",
    totalAmount: "",
    paymentStatus: "",
    amountPaid: "",
    outstandingBalance: "",
    paymentHistory: [],
  });

  const handleEditClick = () => {
    setIsEditable(true);
  };
  const handleDeliveryEdit = () => {
    setDeliveryEditable(true);
  };

  useEffect(() => {
    const getPayDetails = async () => {
      try {
        setIsLoading(true);
        const paymentDetails = await apiService.fetchPaymentDetails(id, token);

        if (!paymentDetails || paymentDetails.length === 0) {
          setEmptyPay(true);
        } else {
          setEmptyPay(false);

          const {
            totalAmount = "",
            currency = "",
            paymentStatus = "",
            amountPaid = "NA",
            outstandingBalance = "NA",
            paymentHistory = [],
          } = paymentDetails;

          setPayment((prevState) => ({
            ...prevState,
            CurrencyStatus: currency,
            totalAmount,
            paymentStatus,
            amountPaid,
            outstandingBalance:
              totalAmount === amountPaid ? 0 : outstandingBalance,
            paymentHistory,
          }));
        }
      } catch (error) {
        console.error("Error in fetching payments: ", error);
        Toast.error("Error fetching payment details.");
      } finally {
        setIsLoading(false);
      }
    };

    getPayDetails();
  }, [id]);

  useEffect(() => {
    const getKioskDetails = async () => {
      try {
        setIsLoading(true);

        const details = await apiService.fetchkioskDetails(id, token);
        setActivationStatus(details.activation.activationStatus);
        setShipmentStatus(details.logistics.logistics.shipment.status);
        setDoctorDetails((prevState) => ({
          ...prevState,
          dwName: details.kiosk?.dwName || "",
        }));
        if (details.legal) {
          setIsContract(true);
          setContractName(details.legal.contract.fileName);
        }
        // Reusable function for formatting dates
        const formatDate = (dateString, fieldName) => {
          let formattedDate = null;
          if (dateString) {
            const date = new Date(dateString);
            if (!isNaN(date.getTime())) {
              formattedDate = date; // Store as Date object
            } else {
              console.warn(`Invalid \`${fieldName}\` value:`, dateString);
            }
          } else {
            console.warn(`Missing \`${fieldName}\` value in response`);
          }
          return formattedDate;
        };

        const address =
          details.logistics.logistics.shipment?.deliveryAddress ||
          "No Address Name found";
        const expectedDeliveryDate = formatDate(
          details.logistics.logistics.shipment?.expectedDeliveryDate,
          "expectedDeliveryDate"
        );
        const actualDeliveryDate = formatDate(
          details.logistics.logistics.shipment?.actualDeliveryDate,
          "actualDeliveryDate"
        );
        const activationValidity = formatDate(
          details.activation?.activationValidity,
          "activationValidity"
        );

        setdeliveryDetails((prevState) => ({
          ...prevState,
          address,
          ExpextedDate: expectedDeliveryDate,
          ActualDate: actualDeliveryDate,
          Validity: activationValidity,
        }));

        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        console.error("Error in fetching kiosk: ", error);
       // Toast.error("Error fetching kiosk details");
      }
    };

    getKioskDetails();
  }, [id]);

  const handleDeliverySaveClick = async () => {
    setDeliveryEditable(false);
    setIsLoading(true);
    try {
      setIsLoading(true);
      await apiService.updateShipment({
        kioskId: id,
        deliveryAddress: deliveryDetails.address,
        expectedDeliveryDate: deliveryDetails.ExpextedDate,
        actualDeliveryDate: deliveryDetails.ActualDate,
        status: shipmentStatus,
        token
      });
      Toast.success(" Delivery Details Updated");
      setIsLoading(false);
    } catch (error) {
      Toast.error("Failed to update delivery details..!");
      setIsLoading(false);
    }
  };
  const handleSaveClick = async () => {
    setIsEditable(false);

    // Handle activation status change

    prevActivationStatus.current = activationStatus; 
    try {
      setIsLoading(true);
      await apiService.updateActivation({
        kioskId: id,
        activationStatus: prevActivationStatus.current,
        validity: deliveryDetails.Validity,
        token
      });
      setIsLoading(false);

      Toast.success("Activation status updated");
    } catch (error) {
      Toast.error("Failed to update activation status..!");
      setIsLoading(false);
    }
  };

  const handleDoctorChange = (e) => {
    const { name, value } = e.target;
    setDoctorDetails((prevDetails) => ({ ...prevDetails, [name]: value }));
  };

  const handleDeliveryChange = (e) => {
    const { name, value } = e.target;
    setdeliveryDetails((prevDetails) => ({ ...prevDetails, [name]: value }));
  };
  const handlePaymentChange = (e) => {
    const { name, value } = e.target;
    setPayment((prevDetails) => ({ ...prevDetails, [name]: value }));
  };

  const handleCurrencyChange = (event) => {
    const { value } = event.target;
    setPayment((prevDetails) => ({ ...prevDetails, CurrencyStatus: value }));
  };

  const handlePaymentStatusChange = (event) => {
    const { value } = event.target;
    setPayment((prevDetails) => ({ ...prevDetails, paymentStatus: value }));
  };

  const handleExpectedDateSelect = (date) => {
    setdeliveryDetails((prevState) => ({
      ...prevState,
      ExpextedDate: date,
    }));
  };
  const handleValidityDateSelect = (date) => {
    setdeliveryDetails((prevState) => ({
      ...prevState,
      Validity: date,
    }));
  };
  const handleActualDateSelect = (date) => {
    setdeliveryDetails((prevState) => ({
      ...prevState,
      ActualDate: date,
    }));
  };

  const handleActivationStatusChange = (event) => {
    setActivationStatus(event.target.value);
  };

  const handleShipmentStatusChange = (event) => {
    setShipmentStatus(event.target.value);
  };

  const HandleStatusConfirm = async () => {
    // Toast.success("Confirmeddd...!!!!");
    try {
      await apiService.updatePaymentSatus(
        id,
        payment.totalAmount,
        payment.CurrencyStatus,
        payment.paymentStatus,
        token
      );
      handleStatusClose();
      Toast.success("Payment Status Updated !!!!");
    } catch (error) {
      Toast.error("Error updating payment status:");
    }
  };

  const handleCreatePayment = async () => {
    try {
      const paymentDetails = {
        kioskId: id,
        totalAmount: payment.totalAmount,
        currency: payment.CurrencyStatus,
        token
      };
      await apiService.createPayment(paymentDetails);
      Toast.success("Payment Created");
      window.location.reload();
    } catch (error) {
      Toast.error("Failed Payment Creation..!");
    }
  };

  const handleUploadContract = async () => {
    const fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.accept = "*/*"; // Accept any type of file
    fileInput.style.display = "none";

    fileInput.onchange = async (event) => {
      const file = event.target.files[0];
      if (file) {
        setSelectedFile(file); 

        try {
          setIsLoading(true);
          // Call the API function to upload the file
          const result = await apiService.uploadContractAPI(id, file, token); 

          setIsLoading(false);
          Toast.success("File uploaded successfully!");
          window.location.reload();
        } catch (error) {
          console.error(
            "Error during upload:",
            error.response?.data || error.message
          );
          Toast.error("File upload failed. Please try again.");
        }
      }
    };

    fileInput.click(); // Open file selection dialog
  };

  const handleDownloadContract = async () => {
    try {
      // Call the centralized API function
      const fileUrl = await apiService.getContractFileUrl(id, token);
      const url = fileUrl.contract.url;
      if (url) {
        // Trigger the file download
        const link = document.createElement("a");
        link.href = url;
        link.target = "_blank"; // Open in a new tab if required
        link.rel = "noopener noreferrer"; // Security best practice
        link.click();
      } else {
        console.error("File URL not returned from the API");
      }
    } catch (error) {
      console.error("Error downloading the contract:", error);
    }
  };

  return (
    <div>
      <Box sx={{ padding: isMobile ? 1 : 3 }}>
        <Title
          icon={<LocalHospitalIcon />}
          text={doctorDetails.clinicName || "clinic Name"}
        />

        <CustomButton
          text="Show Analysis"
          onClick={() => setMonthwise(true)}
          width="250px"
        />
        

        <ExpandBox
          title="Air Details"
          isOpen={openSections.kioskDetails}
          marginTop="10px"
          toggle={() => toggleSection("kioskDetails")}
        >
          <Collapse in={openSections.kioskDetails}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Name"
                  name="name"
                  value={doctorDetails.name}
                  onChange={handleDoctorChange}
                  fullWidth
                  InputProps={{
                    readOnly: true,
                  }}
                  onClick={() => {
                    Toast.info("Cannot change kiosk name from here");
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Location"
                  name="location"
                  value={doctorDetails.location}
                  onChange={handleDoctorChange}
                  fullWidth
                  InputProps={{
                    readOnly: true,
                  }}
                  onClick={() => {
                    Toast.info("Cannot change location from here");
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6} sx={{ marginBottom: "8px" }}>
                <TextField
                  label="License code"
                  name="code"
                  value={doctorDetails.code}
                  onChange={handleDoctorChange}
                  fullWidth
                  InputProps={{
                    readOnly: true,
                  }}
                  onClick={() => {
                    Toast.warning("Cannot change License code");
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6} sx={{ marginBottom: "8px" }}>
                <TextField
                  label="DW Name"
                  name="dwName"
                  value={doctorDetails.dwName}
                  onChange={handleDoctorChange}
                  fullWidth
                  InputProps={{
                    readOnly: true,
                  }}
                  onClick={() => {
                    Toast.info("Cannot change DW name from here");
                  }}
                />
              </Grid>
            </Grid>
          </Collapse>
        </ExpandBox>

        <ExpandBox
          title=" Delivery Details"
          isOpen={openSections.deliveryDetails}
          toggle={() => toggleSection("deliveryDetails")}
        >
          <Collapse in={openSections.deliveryDetails}>
            {!isDeliveryEditable ? (
              <CustomButton
                text="Edit"
                onClick={handleDeliveryEdit}
                width={isMobile ? "110px" : "150px"}
              />
            ) : (
              <Box sx={{ display: "flex", gap: 2 }}>
                <CustomButton
                  backgroundColor="#CCD3DA"
                  color="#000"
                  hoverColor="#A9A9A9"
                  text="Cancel"
                  onClick={() => setDeliveryEditable(false)}
                  width={isMobile ? "110px" : "150px"}
                />
                <CustomButton
                  text="Save"
                  onClick={handleDeliverySaveClick}
                  width={isMobile ? "110px" : "150px"}
                />
              </Box>
            )}

            <Grid container spacing={2} marginBottom={1} marginTop={1}>
              <Grid item xs={12} sm={12}>
                <TextField
                  label="Delivery Address"
                  name="address"
                  value={deliveryDetails.address}
                  onChange={handleDeliveryChange}
                  fullWidth
                  InputProps={{
                    readOnly: !isDeliveryEditable,
                  }}
                  style={{
                    marginBottom: "8px",
                  }}
                />
              </Grid>
            </Grid>

            <Grid container spacing={2} marginBottom={2}>
              <Grid item xs={12} sm={6}>
                <CustomDatePicker
                  selectedDate={deliveryDetails.ExpextedDate}
                  handleDateChange={handleExpectedDateSelect}
                  isDocEditable={isDeliveryEditable}
                  label={"Expected Date"}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <CustomDatePicker
                  selectedDate={deliveryDetails.ActualDate}
                  handleDateChange={handleActualDateSelect}
                  isDocEditable={isDeliveryEditable}
                  label={"Actual Date"}
                />
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12}>
              {/* <Typography variant="h6" gutterBottom>
                  Shipment Status
                </Typography> */}
              <FormControl fullWidth sx={{ marginBottom: "8px" }}>
                <InputLabel
                  shrink={true}
                  sx={{
                    backgroundColor: theme.palette.background.paper,
                  }}
                >
                  Shipment Status
                </InputLabel>
                <Select
                  value={shipmentStatus}
                  onChange={handleShipmentStatusChange}
                  disabled={!isDeliveryEditable}
                >
                  {Object.entries(ShipmentStatus).map(([key, value]) => (
                    <MenuItem key={key} value={value}>
                      {value}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Collapse>
        </ExpandBox>

        <ExpandBox
          title=" Activation Status"
          isOpen={openSections.shipmentStatus}
          toggle={() => toggleSection("shipmentStatus")}
        >
          <Collapse in={openSections.shipmentStatus}>
            {!isEditable ? (
              <CustomButton
                text="Edit"
                onClick={handleEditClick}
                width={isMobile ? "110px" : "150px"}
              />
            ) : (
              <Box sx={{ display: "flex", gap: 2 }}>
                <CustomButton
                  backgroundColor="#CCD3DA"
                  color="#000"
                  hoverColor="#A9A9A9"
                  text="Cancel"
                  onClick={() => setIsEditable(false)}
                  width={isMobile ? "110px" : "150px"}
                />
                <CustomButton
                  text="Save"
                  onClick={handleSaveClick}
                  width={isMobile ? "110px" : "150px"}
                />
              </Box>
            )}
            <Grid container spacing={2} marginTop={1}>
              <Grid item xs={12} sm={6}>
                {/* <Typography variant="h6" gutterBottom>
                  Activation Status
                </Typography> */}
                <FormControl fullWidth sx={{ marginBottom: "8px" }}>
                  <InputLabel
                    shrink={true}
                    sx={{
                      backgroundColor: theme.palette.background.paper,
                    }}
                  >
                    Activation Status
                  </InputLabel>
                  <Select
                    value={activationStatus}
                    onChange={handleActivationStatusChange}
                    disabled={!isEditable}
                  >
                    {Object.entries(ActivationStatus).map(([key, value]) => (
                      <MenuItem key={key} value={value}>
                        {value}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <CustomDatePicker
                  selectedDate={deliveryDetails.Validity}
                  handleDateChange={handleValidityDateSelect}
                  isDocEditable={isEditable}
                  label={"Validity Date"}
                />
              </Grid>
            </Grid>
          </Collapse>
        </ExpandBox>
        <ExpandBox
          title="Payment Status"
          isOpen={openSections.paymentStatus}
          toggle={() => toggleSection("paymentStatus")}
        >
          <Collapse in={openSections.paymentStatus}>
            {!emptyPay ? (
              <>
                <Box sx={{ margin: "10px" }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={2}>
                      <TextField
                        label="Currency"
                        value={payment.CurrencyStatus}
                        fullWidth
                        InputProps={{
                          readOnly: true,
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <TextField
                        label="Total Amount"
                        name="totalAmount"
                        value={payment.totalAmount}
                        fullWidth
                        style={{ marginBottom: "8px" }}
                        InputProps={{
                          readOnly: true,
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="Payment status"
                        value={payment.paymentStatus}
                        fullWidth
                        InputProps={{
                          readOnly: true,
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="Amount Paid"
                        name="amountPaid"
                        value={payment.amountPaid}
                        fullWidth
                        InputProps={{
                          readOnly: true,
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        style={{ marginBottom: "8px" }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="Amount Remaining"
                        name="outstandingBalance"
                        value={payment.outstandingBalance}
                        fullWidth
                        InputProps={{
                          readOnly: true,
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        style={{ marginBottom: "8px" }}
                      />
                    </Grid>
                  </Grid>
                </Box>
                <div
                  style={{
                    display: "flex",
                    flexDirection: isMobile ? "column" : "row",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "1rem",
                  }}
                >
                  <CustomButton
                    text={"Edit Status"}
                    onClick={handleStatusOpen}
                    width={isMobile ? "220px" : "250px"}
                  />

                  <CustomButton
                    text="Add Transaction"
                    onClick={handleOpenDialog}
                    width={isMobile ? "220px" : "250px"}
                  />
                </div>
                <TransactionsList
                  history={payment.paymentHistory}
                  kioskId={id}
                />
              </>
            ) : (
              <Box
                sx={{
                  marginLeft: 2,
                  display: "flex",
                  flexDirection: "column",
                  gap: "1rem",
                }}
              >
                {" "}
                Payment not created.. !
                <CustomButton
                  text={"Set Amount"}
                  onClick={handleStatusOpen}
                  width={isMobile ? "220px" : "250px"}
                />
              </Box>
            )}
          </Collapse>
        </ExpandBox>

        <ExpandBox
          title="Contract"
          isOpen={openSections.contractSection}
          toggle={() => toggleSection("contractSection")}
        >
          <Collapse in={openSections.contractSection}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                  <TextField
                    label="contract"
                    name="contractName"
                    value={contractName}
                    fullWidth
                    InputProps={{
                      readOnly: true,
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    style={{ marginBottom: "8px" }}
                  />
                </Grid>
              </Grid>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: isMobile ? "column" : "row",
                  gap: 2,
                  justifyContent: isMobile && "center",
                  alignItems: "center",
                }}
              >
                <CustomButton
                  text={isContract ? "Re-upload" : "Upload"}
                  onClick={handleUploadContract}
                  width="170px"
                />

                {isContract && (
                  <CustomButton
                    text="Download"
                    onClick={handleDownloadContract}
                    width="170px"
                  />
                )}
              </Box>
            </Box>
          </Collapse>
        </ExpandBox>

        <PaymentStatusDialog
          open={openStatus}
          onClose={handleStatusClose}
          payment={payment}
          emptyPay={emptyPay}
          Currency={Currency}
          Payment={Payment}
          handleCurrencyChange={handleCurrencyChange}
          handlePaymentChange={handlePaymentChange}
          handlePaymentStatusChange={handlePaymentStatusChange}
          handleCreatePayment={handleCreatePayment}
          HandleStatusConfirm={HandleStatusConfirm}
        />
        <TransactionDialog
          open={openDialog}
          onClose={handleCloseDialog}
          kioskId={id}
          history={payment.paymentHistory}
        />
        {showMonthwise && (
          <BarGraphDialog
            open={showMonthwise}
            onClose={handleCloseMonthWise}
            kioskId={id}
          />
        )}
      </Box>
      {isLoading && <PageLoader />}
    </div>
  );
};

export default KioskDetails;
